import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbEnvelope: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M2,4V18a2,2,0,0,0,1.9,2H20.1A2,2,0,0,0,22,18V4ZM20,6V7.35l-8,3.56L4,7.35V6ZM4,18V9.54l8,3.55,8-3.55V18Z' />
        </g>
      </svg>
    </>
  );
};
